// list of domain objects used by flit
export const CIVA = { domain: '.civa.io' };
export const FLIT = { domain: '.flitware.com' };
